import { CardFather, Wrapper } from "./SummeryCardStyle";
import Typogaphy from "../../components/Typography/Typography";
import { HiMap } from "react-icons/hi";
import { Link } from "react-router-dom";
export const SummeryCard = ({
  title,
  Amount,
  bgColor,
  subtitle,
  onlineOrderTitle,
  offlineOrderTitle,
  invoiceOrderTitle,
  unsuccessfullTitle,
  onlineOrder,
  offlineOrder,
  invoiceOrder,
  unsuccessfull,
  row1Icon,
  row2Icon,
  row3Icon,
  row4Icon,
  pathName1,
  pathName2,
  pathName3,
  pathName4,
}) => {
  return (
    <CardFather className="mt-5" bgColor={bgColor}>
      <div className="top-section">
        <Typogaphy weight={"bold"} size={"18px"} fill primary="#fff">
          {title}
        </Typogaphy>
        <Typogaphy
          size={"15px"}
          space={"40px 0px 7px 0px"}
          align={"center"}
          weight={"bold"}
          primary="#fff"
        >
          {subtitle}
        </Typogaphy>
        <Typogaphy
          weight={"bold"}
          align={"center"}
          size={"24px"}
          primary="#fff"
        >
          {Amount}
        </Typogaphy>
      </div>
      <Wrapper>
        <div className="float-section-item">
          <div className="box-holder">
            <div className="img-holder">{row1Icon}</div>
            <div className="content">
              <Link to={pathName1 ? pathName1 : ""}>
                <Typogaphy
                  hover={"color:#009ef7 !important;"}
                  space={"0px 10px 0px 10px"}
                  size={"14px"}
                  lgsize={"13px"}
                  mdsize={"14px"}
                >
                  {onlineOrderTitle}
                </Typogaphy>
              </Link>
              <Typogaphy
                weight={"normal"}
                color={"#a1a5b7"}
                size={"14px"}
                lgsize={"12px"}
                space={"0px 10px 0px 10px"}
                mdsize={"13px"}
                primary={"#a1a5b7"}
              >
                {onlineOrder}
              </Typogaphy>
            </div>
            <div className="icon">{row1Icon}</div>
          </div>
        </div>
        <div className="float-section-item">
          <div className="box-holder">
            <div className="img-holder">{row2Icon}</div>
            <div className="content">
              <Link to={pathName2 ? pathName2 : ""}>
                <Typogaphy
                  hover={"color:#009ef7 !important;"}
                  space={"0px 10px 0px 10px"}
                  size="14px"
                  lgsize={"13px"}
                  mdsize={"14px"}
                >
                  {offlineOrderTitle}
                </Typogaphy>
              </Link>
              <Typogaphy
                weight={"normal"}
                color={"#a1a5b7"}
                size={"14px"}
                lgsize={"12px"}
                space={"0px 10px 0px 10px"}
                mdsize={"13px"}
                primary={"#a1a5b7"}
              >
                {offlineOrder}
              </Typogaphy>
            </div>
            <div className="icon">{row2Icon}</div>
          </div>
        </div>
        <div className="float-section-item">
          <div className="box-holder">
            <div className="img-holder">{row3Icon}</div>
            <div className="content">
              <Link to={pathName3 ? pathName3 : ""}>
                <Typogaphy
                  hover={"color:#009ef7 !important;"}
                  space={"0px 10px 0px 10px"}
                  size="14px"
                  lgsize={"13px"}
                  mdsize={"14px"}
                >
                  {invoiceOrderTitle}
                </Typogaphy>
              </Link>
              <Typogaphy
                weight={"normal"}
                color={"#a1a5b7"}
                size={"14px"}
                lgsize={"12px"}
                space={"0px 10px 0px 10px"}
                mdsize={"13px"}
                primary={"#a1a5b7"}
              >
                {invoiceOrder}
              </Typogaphy>
            </div>
            <div className="icon">{row3Icon}</div>
          </div>
        </div>
        {unsuccessfullTitle ? (
          <div className="float-section-item">
            <div className="box-holder">
              <div className="img-holder">{row4Icon}</div>
              <div className="content">
                <Link to={pathName4 ? pathName4 : ""}>
                  <Typogaphy
                    hover={"color:#009ef7 !important;"}
                    space={"0px 10px 0px 10px"}
                    size="14px"
                    lgsize={"13px"}
                    mdsize={"14px"}
                  >
                    {unsuccessfullTitle}
                  </Typogaphy>
                </Link>
                <Typogaphy
                  weight={"normal"}
                  color={"#a1a5b7"}
                  size={"14px"}
                  lgsize={"12px"}
                  space={"0px 10px 0px 10px"}
                  mdsize={"13px"}
                  primary={"#a1a5b7"}
                >
                  {unsuccessfull}
                </Typogaphy>
              </div>
              <div className="icon">{row4Icon}</div>
            </div>
          </div>
        ) : null}
      </Wrapper>
    </CardFather>
  );
};
